<div class="face-rating">
  <button
    type="button"
    class="face-btn"
    *ngFor="let face of faces"
    [class.selected]="selectedValue() === face.value"
    [disabled]="disabled()"
    [attr.aria-label]="face.labelKey | translate"
    [attr.aria-pressed]="selectedValue() === face.value"
    (click)="onSelect(face.value)">
    <span aria-hidden="true">{{ face.emoji }}</span>
  </button>
</div>
